export default __webpack_public_path__ + "static/media/portharcout 1.d4abd71a.jpg";